<template>
    <div>
        <div class="row" v-loading="loading && gapiLoaded && !error">
            <div class="col-md-3">
                <div class="card">
                    <div class="card-header">
                        <span class="fa fa-cloud"></span> {{trans('projects.fields.folder')}}
                    </div>
                    <div class="card-body" v-if="actualProject.google_drive_folder_id">
                        <a target="_blank" class="btn btn-link"
                           :href="drivePath + actualProject.google_drive_folder_id">
                            <span class="fab fa-google-drive"></span> {{trans('projects.fields.folder')}}
                        </a>
                    </div>
                    <div class="card-footer">
                        <div v-if="!actualProject.google_drive_folder_id">
                            <button class="btn btn-link" @click="createProjectFolder">{{trans('buttons.create_folder')}}
                            </button>
                            <button class="btn btn-link" @click="pickProjectFolder">{{trans('buttons.set_folder')}}
                            </button>
                        </div>
                        <button v-else class="btn btn-link text-danger" @click="pickProjectFolder">
                            {{trans('buttons.edit')}}
                        </button>
                    </div>
                </div>
                <div class="card">
                    <div class="card-header">
                        <span class="fa fa-google"></span> {{trans('projects.fields.datastudio')}}
                        <a class="btn btn-link btn-call-modal pull-right" :href="datastudioReportsEdit">
                            <span>{{trans('buttons.edit')}}</span>
                        </a>
                    </div>
                    <div class="card-body">
                        <table class="table table-sm no-margin">
                            <tbody>
                            <tr v-for="report in datastudio_reports">
                                <td>{{report.name}}
                                    <a target="_blank"
                                       :href="report.link"><span
                                            class="fa fa-external-link"></span></a>
                                </td>
                            </tr>
                            <!--<tr>-->
                            <!--<td>{{trans('projects.fields.datastudio_ppc')}}-->
                            <!--<a target="_blank" v-if="project.datastudio_ppc"-->
                            <!--:href="project.datastudio_ppc"><span-->
                            <!--class="fa fa-external-link"></span></a>-->
                            <!--</td>-->
                            <!--<td><a :href="datastudioPpc"-->
                            <!--class="btn btn-link btn-call-modal"><span>{{trans('buttons.edit')}}</span></a>-->
                            <!--</td>-->
                            <!--</tr>-->
                            <!--<tr>-->
                            <!--<td>{{trans('projects.fields.datastudio_seo')}}-->
                            <!--<a target="_blank" v-if="project.datastudio_seo"-->
                            <!--:href="project.datastudio_seo"><span-->
                            <!--class="fa fa-external-link"></span></a>-->
                            <!--</td>-->
                            <!--<td><a :href="datastudioSeo"-->
                            <!--class="btn btn-link btn-call-modal"><span>{{trans('buttons.edit')}}</span></a>-->
                            <!--</td>-->
                            <!--</tr>-->
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <div class="col-md-9">
                <div class="card">
                    <div class="card-header">
                        <span class="fa fa-chart-bar"></span> {{trans('projects.fields.reports')}}
                    </div>
                    <div class="card-body">
                        <span v-for="projectReport in projectReports" :key="projectReport.id"
                              class="drive-folder-wrapper">
                            <button class="btn btn-link btn-item-remove"
                                    @click="removeDriveFolder(projectReport, 'report')">
                                <span class="fa fa-times"></span>
                            </button>
                            <a target="_blank" :href="drivePath + projectReport.google_drive_id"
                               class="btn btn-link btn-folder"
                            >
                                {{projectReport.visi_group.name}}
                            </a>
                        </span>
                    </div>
                    <div class="card-footer">
                        <button @click="createReportFolder(visi_group)" class="btn btn-link"
                                v-for="visi_group in nonActiveVisiGroupsForReports" :key="visi_group.id">
                            <span class="fa fa-plus"></span> {{visi_group.name}}
                        </button>
                    </div>
                </div>
                <div class="card">
                    <div class="card-header">
                        <span class="fa fa-product-hunt"></span> {{trans('projects.fields.outputs')}}
                    </div>
                    <div class="card-body">
                        <span v-for="projectOutput in projectOutputs" :key="projectOutput.id"
                              class="drive-folder-wrapper">
                            <button class="btn btn-link btn-item-remove"
                                    @click="removeDriveFolder(projectOutput, 'output')">
                                <span class="fa fa-times"></span>
                            </button>
                            <a target="_blank" :href="drivePath + projectOutput.google_drive_id"
                               class="btn btn-link btn-folder"
                            >
                                {{projectOutput.visi_group.name}}
                            </a>
                        </span>
                    </div>
                    <div class="card-footer">
                        <button @click="createOutputFolder(visi_group)" class="btn btn-link"
                                v-for="visi_group in nonActiveVisiGroupsForOutputs" :key="visi_group.id">
                            <span class="fa fa-plus"></span> {{visi_group.name}}
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div>
            <el-dialog
                    :title="modalTitle"
                    :visible.sync="dialogVisible"
                    width="30%"
            >

                <span>Do you want to <strong>choose</strong> Folder from Google Drive or <strong>create</strong> one</span>

                <span slot="footer" class="dialog-footer">
                <el-button type="warning" @click="pickFolder">Pick from Google Drive</el-button>
                <el-button type="primary" @click="createFolder">Create</el-button>
            </span>
            </el-dialog>
        </div>
    </div>
</template>

<script>

    import {Notification} from 'element-ui';

    let _ = require('lodash');
    _.mixin(require("lodash-inflection"));

    export default {
        name: "reports",
        props: {
            project: Object,
            visiGroups: Array,
        },
        data() {
            return {
                dialogVisible: false,

                drivePath: 'https://drive.google.com/drive/folders/',
                pick: null,
                loading: false,
                actualProject: this.project,
                gapiLoaded: false,
                projectReports: [],
                projectOutputs: [],
                datastudio_reports: this.project.datastudio_reports,
                error: false,
                actualVisiGroup: {},
                actualMethod: '',
                message: {
                    folder: {
                        created: 'Folder successfully created',
                        updated: 'Folder successfully updated',
                        removed: 'Folder successfully removed',
                        error: 'Error trying change folder'
                    }
                }
            }
        },
        mounted() {
            this.loadProjectReports();
            this.loadProjectOutputs();

            let vm = this;
            this.$listen('datastudio-reports-updated.' + this.project.id, function(newReports){
                vm.datastudio_reports = newReports;
            });

        },
        created() {
            this.loadGapi();
        },
        computed: {
            modalTitle() {
                return 'Choose/Pick ' + _.lowerCase(this.actualMethod) + ' for ' + this.actualVisiGroup.name;
            },
            datastudioReportsEdit() {
                return laroute.route('projects.datastudio.edit_reports', {project: this.project.id});
            },
            // datastudioPpc() {
            //     return laroute.route('projects.datastudio.edit_ppc', {project: this.project.id});
            // },
            // datastudioSeo() {
            //     return laroute.route('projects.datastudio.edit_seo', {project: this.project.id});
            // },
            nonActiveVisiGroupsForOutputs() {
                let ids = _.map(this.projectOutputs, 'visi_group_id');

                return _.filter(this.visiGroups, function (visiGroup) {
                    return !_.includes(ids, visiGroup.id);
                });
            },
            nonActiveVisiGroupsForReports() {
                let ids = _.map(this.projectReports, 'visi_group_id');

                return _.filter(this.visiGroups, function (visiGroup) {
                    return !_.includes(ids, visiGroup.id);
                });
            }
        },
        methods: {
            trans: function (path) {
                return Lang.trans(path);
            },
            handleRemoveDriveFolder(folder, type) {
                let vm = this;

                axios.post(laroute.route('json.project.project-' + _.pluralize(type) + '.remove', {
                    project: this.actualProject.id,
                    folder: folder.id
                }))
                    .then(response => {
                        if (response.data.id) {

                            if (type === 'output') {
                                vm.projectOutputs = _.filter(vm.projectOutputs, function (output) {
                                    return output.id !== folder.id;
                                });
                            }
                            if (type === 'report') {
                                vm.projectReports = _.filter(vm.projectReports, function (report) {
                                    return report.id !== folder.id;
                                });
                            }
                            Notification.success(vm.message.folder.removed);

                        } else {
                            Notification.error(vm.message.folder.error);
                        }
                    })
                    .catch(error => {
                        console.log(error);

                        Notification.error(vm.message.folder.error);
                    })

            },
            removeDriveFolder(folder, type) {
                let vm = this;
                this.$confirm('This action will unmap folder from this project. Continue?', 'Warning', {
                    confirmButtonText: 'OK',
                    cancelButtonText: 'Cancel',
                    type: 'warning'
                }).then(() => {
                    vm.handleRemoveDriveFolder(folder, type);
                }).catch(() => {

                });
            },
            loadProjectOutputs() {
                let vm = this;
                axios.get(laroute.route('json.project.project-outputs', {
                    project: this.actualProject.id
                }))
                    .then(response => {
                        vm.projectOutputs = response.data;
                    })
                    .catch(error => {
                        console.log(error);
                        vm.error = true;
                    })
            },
            loadProjectReports() {
                let vm = this;
                axios.get(laroute.route('json.project.project-reports', {
                    project: this.actualProject.id
                }))
                    .then(response => {
                        vm.projectReports = response.data;
                    })
                    .catch(error => {
                        console.log(error);
                        vm.error = true;
                    })
            },
            createFolder() {
                // Dialog.$confirm
                // var r = confirm("Are you sure to create output folder for " + visiGroup.name + "?");
                // if (r == true) {
                let vm = this;
                vm.loading = true;
                vm.dialogVisible = false;
                axios.post(laroute.route('json.project.project-' + _.pluralize(this.actualMethod) + '.create', {
                    project: this.actualProject.id,
                    visi_group: this.actualVisiGroup.id
                }))
                    .then(response => {
                        vm.actualVisiGroup = {};

                        if (vm.actualMethod === 'report') {
                            if (!_.isMatch(vm.projectReports, {id: response.id})) {
                                vm.projectReports.push(response.data);
                            }
                        } else if (vm.actualMethod === 'output') {
                            if (!_.isMatch(vm.projectOutputs, {id: response.id})) {
                                vm.projectOutputs.push(response.data);
                            }
                        }

                        vm.actualMethod = '';

                        Notification.success(vm.message.folder.created);
                        vm.loading = false;
                    })
                    .catch(error => {
                        Notification.error(vm.message.folder.error);
                        vm.loading = false;
                    })
                // }
            },
            pickFolder() {
                let vm = this;
                vm.dialogVisible = false;
                this.$pick({upload: false}, function (files) {
                    if (files.length > 0) {
                        let folder = files[0];
                        let id = folder[google.picker.Document.ID];
                        vm.loading = true;

                        axios.post(laroute.route('json.project.project-' + _.pluralize(vm.actualMethod) + '.set', {
                            project: vm.actualProject.id,
                            visi_group: vm.actualVisiGroup.id,
                        }), {
                            folderId: id,
                        })
                            .then(response => {
                                vm.actualVisiGroup = {};

                                if (vm.actualMethod === 'report') {
                                    if (!_.isMatch(vm.projectReports, {id: response.id})) {
                                        vm.projectReports.push(response.data);
                                    }
                                } else if (vm.actualMethod === 'output') {
                                    if (!_.isMatch(vm.projectOutputs, {id: response.id})) {
                                        vm.projectOutputs.push(response.data);
                                    }
                                }
                                vm.actualMethod = '';

                                Notification.success(vm.message.folder.created);
                                vm.loading = false;
                            })
                            .catch(error => {
                                Notification.error(vm.message.folder.error);
                                vm.loading = false;
                            });

                    }
                })
            },
            createOutputFolder(visiGroup) {
                this.actualMethod = 'output';
                this.actualVisiGroup = visiGroup;
                this.dialogVisible = true;
            },
            createReportFolder(visiGroup) {
                this.actualMethod = 'report';
                this.actualVisiGroup = visiGroup;
                this.dialogVisible = true;
            },
            // createReportFolder(visiGroup) {
            //     // var r = confirm("Are you sure to create report folder for " + visiGroup.name + "?");
            //     // if (r == true) {
            //         let vm = this;
            //         vm.loading = true;
            //         axios.post(laroute.route('json.project.project-'+ _.pluralize(this.actualMethod) +'.create', {
            //             project: this.actualProject.id,
            //             visi_group: visiGroup.id
            //         }))
            //             .then(response => {
            //
            //                 if (!_.isMatch(vm.projectReports, {id: response.id})) {
            //                     vm.projectReports.push(response.data);
            //                 }
            //
            //                 Notification.success(vm.message.folder.created);
            //                 vm.loading = false;
            //             })
            //             .catch(error => {
            //                 Notification.error(vm.message.folder.error);
            //                 vm.loading = false;
            //             })
            //     // }
            // },
            pickProjectFolder() {
                let vm = this;
                this.$pick({upload: false}, function (files) {
                    if (files.length > 0) {
                        let folder = files[0];
                        let id = folder[google.picker.Document.ID];

                        vm.updateProjectFolder(id);
                    }
                })
            },
            updateProjectFolder(newId) {
                let vm = this;
                vm.loading = true;

                axios.post(laroute.route('json.project.google-drive.update-folder', {
                    project: this.actualProject.id
                }), {
                    google_drive_folder_id: newId
                })
                    .then(response => {
                        vm.actualProject = response.data;
                        vm.loading = false;

                        Notification.success(vm.message.folder.updated);
                    })
                    .catch(error => {
                        console.log(error);
                        vm.loading = false;
                        Notification.error(vm.message.folder.error);
                    })
            },
            createProjectFolder() {
                let vm = this;
                vm.loading = true;

                axios
                    .post(laroute.route('json.project.google-drive.create-folder',
                        {
                            project: this.actualProject.id
                        }))
                    .then(response => {
                        vm.actualProject = response.data;
                        vm.loading = false;
                        Notification.success(vm.message.folder.created);
                    })
                    .catch(error => {
                        console.log(error);
                        vm.loading = false;
                        Notification.error(vm.message.folder.error);
                    })
            },
            loadGapi() {
                let vm = this;
                let script = document.createElement('script');
                script.onload = () => {

                    vm.gapiLoaded = true
                };

                script.async = true;
                script.src = 'https://apis.google.com/js/api.js';
                document.head.appendChild(script);
            }
        }
    }
</script>

<style scoped lang="scss">

    .drive-folder-wrapper {
        position: relative;

        &:hover,
        &:focus {
            .btn-item-remove {
                display: block;
            }
        }

        .btn-item-remove {
            position: absolute;
            display: none;
            top: -16px;
            left: -10px;
            color: #dc3545
        }

    }

</style>


// WEBPACK FOOTER //
// resources/assets/js/components/projects/Reports.vue